module.exports = __webpack_public_path__ + "img/antes_despues_295.9d4a29c7.png";